import { Trans, t } from '@lingui/macro';
import { ErrorCard } from 'components/ErrorCard/ErrorCard';
import { Link } from 'react-router-dom';
import { PATH_NAMES } from 'utils/routes/pathNames';

export const NotFound = () => {
  return (
    <ErrorCard
      code={404}
      message={t`The link you followed may be broken, or may have been mistyped.`}
      action={
        <Link to={PATH_NAMES.home()}>
          <Trans>Return to dashboard</Trans>
        </Link>
      }
    />
  );
};
